export type OrderSide = 'Long' | 'Short' | 'unknown';

/**
 * 클라이언트 검증에서 "reduce-only로 취급할지" 판정하는 순수 로직.
 *
 * reduce-only 체크박스가 꺼져 있어도, one-way 모드에서 열린 포지션과 **반대 방향** 주문은
 * 포지션을 줄이는(감소) 주문이므로 reduce-only처럼 취급한다 → 상한(leverage/notional) 검증을 스킵.
 * (bracket.ts의 canSkipValidateAtom과 동일한 opposite 판정)
 *
 * 주의: 이건 **클라 검증용**이다. 서버로 보내는 submit payload의 reduceOnly는 명시 플래그를 그대로 쓴다
 * (반대 방향 주문은 실제로는 일반 주문이라 reduceOnly=false로 전송).
 */
export const isEffectiveReduceOnly = (params: {
  explicitReduceOnly: boolean;
  isOneWay: boolean;
  /** 현재 열린 포지션의 side (없으면 undefined) */
  openPositionSide: OrderSide | undefined | null;
  /** 주문 방향 */
  orderSide: OrderSide;
}): boolean => {
  const { explicitReduceOnly, isOneWay, openPositionSide, orderSide } = params;

  if (explicitReduceOnly) return true;
  if (!isOneWay) return false;

  return openPositionSide != null && orderSide !== 'unknown' && openPositionSide !== orderSide;
};
